/** @jsx jsx */
import React, { useRef } from 'react'
import { Box, Flex, jsx } from 'theme-ui'
import styled from '@emotion/styled'
import { NavLink, NavSpacer } from './Nav'
import Button from '../Buttons/Button'
import { LPButton } from '../../blocks/LPButtonComponent'

import { useWindowSize } from '../../../hooks/useWindowSize'

const FixedNav = styled.div`
  position: ${p => (p.sticky ? 'fixed' : 'absolute')};
  top: 0;
  width: 100%;
  z-index: ${p => p.theme.zIndex[4] + 2};
`

const NavWrapper = styled.div`
  background: white;
  height: ${p => p.theme.sizes.navHeight}px;
  z-index: ${p => p.theme.zIndex[4] + 2};
  box-shadow: ${p => p.theme.shadows.navBottomShadow};
`

const LPNav = ({ data: navBar, cta, productInfo, useAddToCartBtn }) => {
  const { mobile } = useWindowSize()
  return [
    <FixedNav sticky={!mobile && true}>
      <NavWrapper>
        <header
          sx={{
            margin: 'auto',
            display: 'grid',
            gridGap: 3,
            maxWidth: 'pageMaxWidth',
            mx: 'auto',
            px: [12, 20, 20, 20, 20, 70],
            gridAutoFlow: 'row',
            gridTemplateColumns: [
              '2fr 2fr',
              '2fr 2fr',
              '2fr 2fr',
              '2fr 2fr',
              '1fr 1fr',
            ],
            variant: 'styles.header',
            zIndex: 2,
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
          }}
        >
          <Flex
            sx={{
              alignItems: 'stretch',
              justifyContent: ['center', null, null, null, 'flex-start'],
              margin: [0, null, null, null, 0],
            }}
          >
            <NavLink to={navBar.brandLogoToSlug || '/'} title="Home">
              <img
                sx={{
                  width: ['158px'],
                  variant: 'styles.navlink',
                  p: 0,
                  px: 0,
                }}
                src={navBar.brandLogo.file.url}
                alt="jaxxon"
              />
              <span
                sx={{
                  position: 'absolute',
                  width: 1,
                  height: 1,
                  overflow: 'hidden',
                  top: -9999,
                }}
              >
                Home
              </span>
            </NavLink>
          </Flex>

          <Flex
            sx={{
              alignItems: 'center',
              justifyContent: 'flex-end',

              height: '100%',
            }}
          >
            {useAddToCartBtn ? (
              <LPButton
                buttonProps={{
                  buttonLabel: 'Add To Cart',
                  buttonSize: 'small',
                  buttonStyle: 'black',
                }}
                sx={{ minWidth: ['150px', '250px'], minHeight: '52px' }}
                productInfo={productInfo}
              />
            ) : (
              <Button
                sx={{ minWidth: ['150px', '250px'], minHeight: '52px' }}
                size="small"
                variant="black"
                to={`products/${cta}`}
              >
                Shop Now
              </Button>
            )}
          </Flex>
        </header>
      </NavWrapper>
    </FixedNav>,
    <NavSpacer
      customHeight={theme => [
        `${theme.sizes.mobileNavHeight}px`,
        `${theme.sizes.mobileNavHeight}px`,
        `${theme.sizes.navHeight}px`,
      ]}
    />,
  ]
}

export default LPNav
